// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.getclave",
    name: "Clave",
    homepage: "https://getclave.io",
    image_id: "f1c538df-15d9-4448-542f-b7b358e95d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/gr/app/clave-smart-wallet/id6449253761",
        android: "https://play.google.com/store/apps/details?id=com.clave.mobile",
        mac: "https://apps.apple.com/gr/app/clave-smart-wallet/id6449253761",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "clave://link/wc/",
        universal: "https://getclave.io/link/wc",
    },
    desktop: {
        native: "clave://link/wc/",
        universal: "https://getclave.io/link",
    },
};
//# sourceMappingURL=index.js.map